import type { MaybeRefOrGetter } from 'vue';
import type { CollectionFieldPath, ResolvedMonospaceCollection } from '#layers/data-model/public';
import { toValue } from 'vue';
import { usePermissionsStore } from '#layers/access/public';
import { outputReturnsFieldPath, QueryCapabilityKinds, resolveCollectionFieldPath, supportedSurface, useQueryApi } from '#layers/data-model/public';

/**
 * The field paths a listing may show: the user may read every segment, and the collection's list
 * read returns the path. System collections return every readable path.
 */
export function useOutputGate(collection: MaybeRefOrGetter<ResolvedMonospaceCollection | undefined>) {
	const output = useQueryApi(collection).surface((api) => api.readMany()?.output());
	const permissions = usePermissionsStore();

	function allowsPath(fieldPath: CollectionFieldPath): boolean {
		const current = toValue(collection);
		const segments = current && resolveCollectionFieldPath(current, fieldPath);
		if (!current || !segments?.every(({ collection, field }) => permissions.canReadField(collection.id, field))) return false;
		if (output.value.kind === QueryCapabilityKinds.Ungated) return true;

		const surface = supportedSurface(output.value);
		return !!surface && outputReturnsFieldPath(surface, current, fieldPath);
	}

	return { allowsPath };
}
